import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M11.852 2.011l.058 -.007l.09 -.004l.075 .003l.126 .017l.111 .03l.111 .044l.098 .052l.104 .074l.082 .073l3 3a1 1 0 1 1 -1.414 1.414l-1.293 -1.292v7.585a1 1 0 0 1 -2 0v-7.585l-1.293 1.292a1 1 0 0 1 -1.32 .083l-.094 -.083a1 1 0 0 1 0 -1.414l3 -3q .053 -.054 .112 -.097l.11 -.071l.114 -.054l.105 -.035z","key":"svg-0"}],["path",{"d":"M12 16a3 3 0 1 1 0 6a3 3 0 0 1 0 -6","key":"svg-1"}]]

const IconArrowMoveUpFilled = createReactComponent('filled', 'arrow-move-up-filled', 'ArrowMoveUpFilled', __iconNode);

export default IconArrowMoveUpFilled;